import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { ThrillerDanceComponent } from "./components/ThrillerDanceComponent";
import { WordleComponent } from "./components/WordleComponent";
import { BinoMiniGameComponent } from "./components/BinocularsComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { KeypadComponent } from "./components/KeypadComponent";
import { MiniKeypadComponent } from "./components/MiniKeypadComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-dance", ThrillerDanceComponent);
window.customElements.define("game-wordle", WordleComponent);
window.customElements.define("game-binos", BinoMiniGameComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-keypad", KeypadComponent);
window.customElements.define("game-minikeypad", MiniKeypadComponent);
